import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
const ENERGY_CLASSES = {
    'A+++': 1,
    'A++': 1,
    'A+': 1,
    A: 1,
    B: 1,
    C: 1,
    D: 1,
    E: 1
};
/**
 * Energy Class Parser.
 */
export default class EnergyClassParser {
    /**
     * Parses product and returns energy class.
     *
     * @param product Product item.
     * @returns EnergyClass.
     */
    static parseProduct(product) {
        const complianceTechnicalEnergyFlag = this.parseProductComplianceTechnical(product);
        return complianceTechnicalEnergyFlag
            ? complianceTechnicalEnergyFlag
            : this.parseProductTechnicalInformation(product);
    }
    /**
     * Parses the technicalInformation object array if there is a Energy Efficiency Class header type available.
     *
     * @param product Product item.
     * @returns EnergyClass.
     */
    static parseProductTechnicalInformation(product) {
        if (!product.content?.technicalInformation?.length) {
            return null;
        }
        for (const item of product.content.technicalInformation) {
            if (typeof item.valueMetric === 'string') {
                if (ENERGY_CLASSES[item.valueMetric]) {
                    return item.valueMetric;
                }
            }
        }
        return null;
    }
    /**
     * Parses the complianceTechnical object array if there is a Energy Efficiency Class header type available.
     *
     * @param product Product item.
     * @returns EnergyClass.
     */
    static parseProductComplianceTechnical(product) {
        if (!product.content?.complianceTechnical?.length) {
            return null;
        }
        const item = product.content.complianceTechnical.find((value) => value.headingType === ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass);
        if (typeof item?.text === 'string') {
            if (ENERGY_CLASSES[item.text]) {
                return item.text;
            }
        }
        return null;
    }
}
//# sourceMappingURL=EnergyClassParser.js.map